import React, { Fragment } from "react";
import styled from "styled-components";
import Label from "../Label";

const CheckboxContainer = styled.div`
  input[type="checkbox"] {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  label:before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    padding: 8px;
    margin-right: 10px;
    vertical-align: -3px;
    border: 1px solid ${(props) => props.theme.colors.darkGray};
    background-color: white;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }

  label {
    display: flex;
    margin-right: 1em;
    margin-bottom: 0rem;
    position: relative;
    color: ${(props) => props.theme.colors.black};
    font-size: 16px;
    font-family: ${(props) => props.theme.fonts.heading};
    font-weight: ${(props) => props.theme.fonts.weights.normal};
  }

  input:hover + label:before {
    border-color: ${(props) => props.theme.colors.info};
  }

  input:checked + label:before {
    border-color: ${(props) => props.theme.colors.info};
  }

  label:after {
    content: "";
    border: solid ${(props) => props.theme.colors.info};
    border-width: 0 3px 3px 0;
    left: 5px;
    top: 3px;
    position: absolute;
    transform: rotate(45deg);
    display: none;
  }

  input:disabled + label {
    border-color: ${(props) => props.theme.colors.darkGray};
    color: ${(props) => props.theme.colors.darkGray};
  }

  input:disabled + label:before {
    border-color: ${(props) => props.theme.colors.darkGray};
    background: ${(props) => props.theme.colors.lightGray};
  }

  input:not([disabled]):checked + label:after {
    -moz-animation: check 0.8s ease 0s running;
    -webkit-animation: check 0.8s ease 0s running;
    animation: check 0.8s ease 0s running;
    display: block;
    width: 7px;
    height: 10px;
    border-color: ${(props) => props.theme.colors.info};
  }

  input:disabled:checked + label:after {
    border-color: #d2d2d2;
    display: block;
  }
`;
CheckboxContainer.displayName = "CheckboxContainer";

const CheckboxField = ({
  id,
  disabled,
  checked,
  name,
  onChange,
  children,
  error = true,
  errorText,
}) => (
  <Fragment>
    <CheckboxContainer>
      <input
        type="checkbox"
        onChange={onChange}
        name={name}
        disabled={disabled}
        defaultChecked={checked}
        id={id}
      />
      <label htmlFor={id}>{children}</label>
    </CheckboxContainer>
    {!error && (
      <Label error marginVertical="8px" weight="500">
        {errorText}
      </Label>
    )}
  </Fragment>
);
CheckboxField.displayName = "CheckboxField";

export default CheckboxField;
